import type { StorageDashboardSummary } from './storageDashboardTypes';
import {
  formatStorageDashboardDate,
  formatStorageDashboardFileSize
} from './storageDashboardFormatters';

export function StorageLatestFilesCard({ summary }: { summary: StorageDashboardSummary }) {
  return (
    <section className="dashboard-card dashboard-card--storage">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Latest Files</h3>
          <p>Recently modified files at storage roots</p>
        </div>
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.filesUpdatedLast7Days}</span>
          <span className="dashboard-kpi__label">Updated (7d)</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.filesListedAtRoots}</span>
          <span className="dashboard-kpi__label">Listed at roots</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Newest Files</h4>
        {summary.latestFiles.length === 0 ? (
          <p className="dashboard-empty">No files found at the root of your accessible mounts.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.latestFiles.map((item) => (
              <li key={`${item.mountId}:${item.path}`}>
                <span>
                  <strong>{item.name}</strong>
                  <small>
                    {item.mountDisplayName} · {formatStorageDashboardFileSize(item.sizeBytes)}
                  </small>
                </span>
                <span>{formatStorageDashboardDate(item.lastModified)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
